import { Component } from '@angular/core';
import { NgControl, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'src/shared/validators/custom-validators';
import {
	FormConfig,
	CustomFormAccessor,
} from 'src/shared/form-models/form-cva.component';
import { PayrollOptions } from '../railroad-detail.models';

const billingAmountValidator = [
	CustomValidators.mustBeNumeric,
	Validators.min(0),
];

const railroadPayrollOptionsFormConfig: FormConfig<PayrollOptions> = {
	nonflaggingHourlyRate: ['', billingAmountValidator],
	dailyCellPhoneReimbursementRate: [''],
	hotelPerDiemA: ['', billingAmountValidator],
	mealPerDiemA: ['', billingAmountValidator],
	hotelPerDiemB: ['', billingAmountValidator],
	mealPerDiemB: ['', billingAmountValidator],
	mealBonusApplies: [''],
	mileageReimbursed: [''],
	travelTimeApplies: [''],
	conferenceCallHourlyRate: ['', billingAmountValidator],
	trainingHourlyRate: ['', billingAmountValidator],
	travelHourlyRate: ['', billingAmountValidator],
	drugTestHourlyRate: ['', billingAmountValidator],
	minimumShiftHours: ['', Validators.min(0)],
};

@Component({
	selector: 'rpfsa-payroll-options',
	templateUrl: './payroll-options.component.html',
})
export class PayrollOptionsComponent extends CustomFormAccessor<
	PayrollOptions
> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, railroadPayrollOptionsFormConfig);
	}

	// model --> view
	writeValue(value: PayrollOptions): void {
		super.writeValue(value);
	}

	// view --> model
	registerOnChange(fn: (value: PayrollOptions) => void) {
		super.registerOnChange(fn);
	}
}
